<template>
  <a-form
    class="simiot-nested-search-form diagnose-search-form"
    :form="form"
    @submit="handleSearch"
  >
    <a-row :gutter="24">
      <a-col :span="6">
        <a-form-item>
          <a-space>
            <a-button type="primary" html-type="submit">
              开始诊断
            </a-button>
          </a-space>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
export default {
  name: 'SearchSimCardDiagnose',
  props: {
    simCardId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'sim_card_diagnose_search' })
    }
  },
  methods: {
    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    },

    handleSearch(e) {
      e.preventDefault()
      this.$emit('submit', this.form.getFieldsValue())
    }
  }
}
</script>

<style lang="less" scoped>
.diagnose-search-form {
  margin-bottom: 10px;
}
</style>
